import React, { useState, useEffect } from 'react';
import { Settings, Building2, Plug, Users, FileText, Key, MessageSquare, CheckCircle2, AlertCircle, CalendarClock} from 'lucide-react';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import EditableField from '../../../components/EditableFields';
import ConfiguracionServiciosEmpresas from './ConfiguracionServiciosEmpresas';
import BooleanField from '../../../components/BooleanField';
import { useConfiguracionModel } from '../../../modelos/Configuracion/modelo_configuracion';
import { useLocation, useNavigate } from 'react-router-dom';
import RenderCuentasSection from './Modulos/renderCuentasSection'; 
import { formatearFechaCompleta } from '../../../utils/utils';

const ConfiguracionAdmin = () => {
  const {
    updateConfiguracion,
    deleteConfiguracionCuentaProfesional,
    actualizacionTutores,
    repararIndicesSolicitudes,
    repararPrecios
  } = useConfiguracionModel();

  const location = useLocation();
  const navigate = useNavigate();
  const activeSection = location.hash.substring(1) || 'empresa';

  const { 
    configuracion, 
    loadingConfiguracion, 
    recargarConfiguracion,
  } = useConfiguracion();

  //cuentas
  const  handleAgregarCuenta = async (nuevaCuenta) =>{

    await updateConfiguracion(configuracion.nombreEmpresa,'cuentaProfesional',nuevaCuenta,'array_insert');

    recargarConfiguracion();
    
  }
  const handleEliminarCuenta = (cuenta) =>{
    deleteConfiguracionCuentaProfesional(configuracion.nombreEmpresa,cuenta);

    recargarConfiguracion();
  }

  const secciones = [
    { id: 'empresa', nombre: 'Datos Empresa', icono: Building2 },
    { id: 'plugins', nombre: 'Plugins', icono: Plug },
    { id: 'globales', nombre: 'Configuración Global', icono: Settings },
    { id: 'credenciales', nombre: 'Credenciales', icono: MessageSquare },
    { id: 'mensajes', nombre: 'Mensajes', icono: Key },
  ];

  const renderEmpresaSection = () => (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg border">
        <h3 className="text-lg font-semibold mb-4 flex items-center">
          <Building2 className="mr-2 h-5 w-5" />
          Información de la Empresa
        </h3>

        <div className="space-y-4">
          <div>
            {configuracion.nombreEmpresa}
          </div>

          <ConfiguracionServiciosEmpresas
            configuracion={configuracion} />
        </div>
        

        
      </div>
    </div>
  );

  const handleSave = async(field,value,categoria="CONFIGURACION") =>{
    console.log("a actualizar",field,value);
    await updateConfiguracion(configuracion.nombreEmpresa,field,value,'field',categoria);

    recargarConfiguracion();
  }

  const handleSaveCuentaProfesional = async(field,value,cuenta) =>{

    const finalupdate = {
        "value" : value,
        "elementId": cuenta.nombreCuenta,
      }

    await updateConfiguracion(configuracion.nombreEmpresa,field,finalupdate,'array');

    recargarConfiguracion();
  }

  const SectionDivider = ({ label }) => (
    <div className="pt-4 pb-2">
      <div className="flex items-center">
        <span className="pr-3 text-xs font-bold uppercase tracking-widest text-gray-400">
          {label}
        </span>
        <div className="flex-1 h-px bg-gray-200"></div>
      </div>
    </div>
  );

  const WidgetTemporadaActualizacion = ({ fechaLimite }) => {
    // Convertimos la fecha a objeto Date para comparar
    const fechaActual = new Date();
    const fechaLimiteDoc = new Date(fechaLimite);
    
    // Si la fecha límite es mayor a hoy, la temporada está activa
    const estaActiva = fechaLimiteDoc > fechaActual;

    return (
      <div className={`p-4 rounded-xl border-2 transition-all ${
        estaActiva 
          ? "bg-green-50 border-green-200 shadow-sm" 
          : "bg-gray-50 border-gray-200"
      }`}>
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            {estaActiva ? (
              <CheckCircle2 className="text-green-600 h-5 w-5" />
            ) : (
              <AlertCircle className="text-gray-400 h-5 w-5" />
            )}
            <span className={`font-bold text-sm uppercase tracking-wider ${
              estaActiva ? "text-green-700" : "text-gray-500"
            }`}>
              {estaActiva ? "Temporada de Actualización Activa" : "No hay actualización de tutores"}
            </span>
          </div>
          
          {/* Indicador visual de color (Punto) */}
          <div className={`h-3 w-3 rounded-full animate-pulse ${
            estaActiva ? "bg-green-500" : "bg-gray-300"
          }`} />
        </div>

        <div className="flex items-center gap-2 text-sm text-gray-600">
          <CalendarClock className="h-4 w-4" />
          <p>
            {estaActiva 
              ? `Disponible hasta el: ` 
              : `Última temporada finalizó: `}
            <span className="font-semibold">{formatearFechaCompleta(fechaLimite)}</span>
          </p>
        </div>
      </div>
    );
  };

  const renderPluginsSection = () => (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg border">
        <h3 className="text-lg font-semibold mb-4 flex items-center">
          <Plug className="mr-2 h-5 w-5" />
          Plugins del Sistema 
        </h3>
        
        <div className="space-y-4">
          {/* Plugin Solicitudes */}
          <div className="border rounded-lg p-4 bg-gray-50">
            <span className={`px-2 py-1 text-xs rounded-full ${
                configuracion.pluginSolicitudes 
                  ? 'bg-green-100 text-green-800' 
                  : 'bg-red-100 text-red-800'
              }`}>
                {configuracion.pluginSolicitudes ? 'Activo' : 'Inactivo'}
              </span>
            
            <EditableField
                  field="idcarpetaSolicitudes"
                  label="Id carpeta solicitudes"
                  value={configuracion.idcarpetaSolicitudes}
                  type="text"
                  isAdmin={true}
                  onSave={(field, value) => handleSave(field, value)}
                  placeholder="Ingrese el id de la carpeta de solicitud"
                />

          </div>

          {/* Plugin Carpeta de Pagos */}
          <div className="border rounded-lg p-4 bg-gray-50">
            <span className={`px-2 py-1 text-xs rounded-full ${
                configuracion.pluginCarpetaPagos 
                  ? 'bg-green-100 text-green-800' 
                  : 'bg-red-100 text-red-800'
              }`}>
                {configuracion.pluginCarpetaPagos ? 'Activo' : 'Inactivo'}
              </span>

            <EditableField
                  field="idcarpetaPagos"
                  label="Id carpeta pagos"
                  value={configuracion.idcarpetaPagos}
                  type="text"
                  isAdmin={true}
                  onSave={(field, value) => handleSave(field, value)}
                  placeholder="Ingrese la materia"
                />
              
          </div>

          {/* Plugin Entrega de Tutores */}
          <div className="border rounded-lg p-4 bg-gray-50">
            <span className={`px-2 py-1 text-xs rounded-full ${
                configuracion.pluginEntregaTutores 
                  ? 'bg-green-100 text-green-800' 
                  : 'bg-red-100 text-red-800'
              }`}>
                {configuracion.pluginEntregaTutores ? 'Activo' : 'Inactivo'}
              </span>
              <EditableField
                  field="idcarpetaEntregaTutores"
                  label="Id carpeta de entregas de tutores"
                  value={configuracion.idcarpetaEntregaTutores}
                  type="text"
                  isAdmin={true}
                  onSave={(field, value) => handleSave(field, value)}
                  placeholder="Ingrese la materia"
              />
          </div>


          {/* WhatsApp Business Api */}
          <div className="bg-white p-6 rounded-lg border">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold flex items-center">
                <Users className="mr-2 h-5 w-5" />
                WhatsApp Business API
              </h3>
              
            </div>

            id whatsp facebook {configuracion.idWhatsappFacebook}
            token whatsapp {configuracion.tokenWhatsappFacebook}
            id cuenta whatsap {configuracion.idCuentaWhatsapp}
            
            
          </div>

        </div>
      </div>
    </div>
  );

  const renderGlobalesSection = () => (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg border">
        <h3 className="text-lg font-semibold mb-4 flex items-center">
          <Settings className="mr-2 h-5 w-5" />
          Configuraciones Globales
        </h3>
        
        <div className="space-y-3">

          <SectionDivider label="Generales" />

          <BooleanField
            field="pagoExtraTemporaneo"
            label="Habilitar pago extratemporaneo a tutores"
            value={configuracion.pagoExtraTemporaneo}
            isAdmin={true}
            displayAs='toggle'
            onSave={handleSave}
          />

          <BooleanField
            field="manejoPagoSocios"
            label="Manejo pago a socios (REFERIDOS)"
            value={configuracion.manejoPagoSocios}
            isAdmin={true}
            displayAs='toggle'
            onSave={handleSave}
          />

          {configuracion.nombreEmpresa == "DUFY ASESORIAS" && (
            <>

             <BooleanField
              field="aceptarNuevosTutores"
              label="Aceptar nuevos tutotores"
              value={configuracion.aceptarNuevosTutores}
              isAdmin={true}
              displayAs='toggle'
              onSave={handleSave}
            />
            </>
          )}

          <SectionDivider label="Extras" />

          <BooleanField
            field="manejoProPlataforma"
            label="Manejo de proPlataforma"
            value={configuracion.manejoProPlataforma}
            isAdmin={true}
            displayAs='toggle'
            onSave={handleSave}
          />

          <BooleanField
            field="manejoTesis"
            label="Manejo de tesis"
            value={configuracion.manejoTesis}
            isAdmin={true}
            displayAs='toggle'
            onSave={handleSave}
          />

          <BooleanField
            field="manejoWhatsapp"
            label="Manejo de Whatsapp"
            value={configuracion.manejoWhatsapp}
            isAdmin={true}
            displayAs='toggle'
            onSave={handleSave}
          />

           <SectionDivider label="Limpiezas" />

           <div className="flex flex-wrap gap-3 pt-2">
            <button
              onClick={async() => { 

                await repararIndicesSolicitudes();

              }}
              className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-all active:scale-95 shadow-sm"
            >
              Limpiar cache de estados
            </button>

            <button
              onClick={async() => { 

                await actualizacionTutores(configuracion.nombreEmpresa);

                await recargarConfiguracion();

               }}
              className="px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-all active:scale-95 shadow-sm"
            >
              Activar Actualización de tutores
            </button>

            <button
              onClick={async() => {

                await repararPrecios();

              }}
              className="px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-all active:scale-95 shadow-sm"
            >
              Cambiar precios = 1 a 0 pesos
            </button>

          </div>

          <WidgetTemporadaActualizacion 
            fechaLimite={configuracion.actualizacionTutores} 
          />
          
        </div>
      </div>
    </div>
  );

  const redenrMensajesSection = () => {
    const mensajes = [
      { key: 'CONFIRMACION_CLIENTE', label: 'Confirmación de Cliente', description: 'Mensaje enviado para confirmar datos del cliente' },
      { key: 'SOLICITUD', label: 'Solicitud General', description: 'Mensaje para solicitudes generales' },
      { key: 'plantillaSolicitudTesis', label: 'Plantilla Solicitud de Tesis', description: 'Plantilla para solicitudes de tesis' },
      { key: 'plantillaSolicitudAsesoria', label: 'Plantilla Solicitud de Asesoría', description: 'Plantilla para solicitudes de asesoría' },
      { key: 'plantillaSolicitudExamen', label: 'Plantilla Solicitud de Examen', description: 'Plantilla para solicitudes de examen' },
      { key: 'plantillaSolicitudTaller', label: 'Plantilla Solicitud de Taller', description: 'Plantilla para solicitudes de taller' }
    ];

    const allMessageStrings = mensajes
      .map(m => configuracion?.[m.key])
      .filter(Boolean) // Quitar mensajes nulos o vacíos
      .join(' ');

    const variableRegex = /({[^}]+}|\/[^/]+\/)/g;
    let detectedVariables = [];
    const allMatches = allMessageStrings.match(variableRegex);
    if (allMatches) {
      // Usar un Set para eliminar duplicados y luego convertir a array, ordenado
      detectedVariables = [...new Set(allMatches)].sort();
    }

    /**
     * Función para formatear el texto del mensaje y resaltar variables.
     * Devuelve JSX, que la prop `formatDisplay` de EditableField renderizará.
     */
    const formatMessageWithHighlighting = (text) => {
      // Si no hay texto, usa el placeholder de EditableField
      if (!text) {
         // El `displayValue` de EditableField mostrará "No especificado"
         // así que podemos devolver null o el texto que queramos.
        return <span className="text-gray-400 italic">No especificado</span>;
      }
      
      // Regex para encontrar /variable/ o *variable*
      // El ( ) captura los delimitadores para que .split() los conserve
      const parts = text.split(/(\/[^/]+\/|\*.*?\*)/g);
      
      return (
        <span className="whitespace-pre-wrap font-mono">
          {parts.map((part, index) => {
            if (!part) return null;
            
            // Resalta variables tipo /variable/
            if (part.startsWith('/') && part.endsWith('/')) {
              return (
                <strong key={index} className="text-blue-600 bg-blue-100 px-1 rounded">
                  {part}
                </strong>
              );
            }
            // Resalta variables tipo *variable* (negrita)
            if (part.startsWith('*') && part.endsWith('*')) {
              return (
                <strong key={index} className="font-bold text-gray-900">
                  {part}
                </strong>
              );
            }
            // Retorna el texto normal
            return part;
          })}
        </span>
      );
    };

    return (
      <div className="space-y-6">
        <div className="bg-white p-6 rounded-lg border">
          <h3 className="text-lg font-semibold mb-4 flex items-center">
            <FileText className="mr-2 h-5 w-5" />
            Configuración de Mensajes , SOLO MODIFICABLE DESDE EDUSMART
          </h3>
          
          <div className="space-y-6">
            {/* Mapeamos los mensajes y creamos una "tarjeta" para cada uno.
              Dentro de ella, solo irá el EditableField.
            */}
            {mensajes.map((mensaje) => (
              <div key={mensaje.key} className="border rounded-lg p-4 bg-gray-50">
                {/* 1. Mostramos el título y la descripción */}
                <div className="mb-3">
                  <h4 className="font-medium text-gray-800 mb-1">{mensaje.label}</h4>
                  <p className="text-sm text-gray-600">{mensaje.description}</p>
                </div>
                
                {/* 2. Usamos EditableField para TODO (mostrar y editar).
                  - Pasamos la función de resaltado a `formatDisplay`.
                  - Ocultamos el 'label' de EditableField porque ya tenemos el 'h4'.
                  - Sobrescribimos la clase para que tenga fondo blanco.
                */}
                <EditableField
                  field={mensaje.key}
                  label="" // Ocultamos el label de EditableField, ya usamos el h4
                  value={configuracion?.[mensaje.key] || ''}
                  type="textarea"
                  isAdmin={true}
                  onSave={(field, value) => handleSave(field, value, "MENSAJES")}
                  placeholder={`Ingrese el mensaje para ${mensaje.label.toLowerCase()}`}
                  rows={8} // Damos más espacio para editar
                  formatDisplay={formatMessageWithHighlighting} // <-- ¡AQUÍ ESTÁ LA MAGIA!
                  className="bg-white" // Sobrescribe el bg-gray-50 por defecto
                />
              </div>
            ))}
          </div>
        </div>

        {/* --- 4. SECCIÓN DE VARIABLES (ACTUALIZADA) --- */}
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
          <h4 className="font-medium text-blue-800 mb-3 flex items-center">
            <Key className="mr-2 h-4 w-4" />
            Variables Detectadas en Mensajes
          </h4>
          
          {/* Reemplazamos el grid estático por esta lógica dinámica */}
          {detectedVariables.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-2 text-sm">
              {detectedVariables.map((variable) => (
                // Usamos 'code' para semántica y le damos estilo
                <code key={variable} className="text-blue-700 bg-blue-100 px-2 py-1 rounded break-all">
                  {variable}
                </code>
              ))}
            </div>
          ) : (
            <p className="text-sm text-blue-700">
              No se detectaron variables (como {'{variable}'} o /variable/) en los mensajes configurados.
            </p>
          )}
          
        </div>

      </div>
    );
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'empresa':
        return renderEmpresaSection();
      case 'plugins':
        return renderPluginsSection();
      case 'globales':
        return renderGlobalesSection();
      case 'credenciales':
        return <RenderCuentasSection
          configuracion={configuracion}
          onAgregarCuenta={handleAgregarCuenta}
          onEliminarCuenta={handleEliminarCuenta}
          onEditarCuenta={handleSaveCuentaProfesional}
        />
      case 'mensajes':
        return redenrMensajesSection();
      default:
        return renderEmpresaSection();
    }
  };

  if (loadingConfiguracion) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto flex flex-col items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-gray-600">Cargando la configuracion...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar */}
          <div className="lg:w-1/4">
            <div className="bg-white rounded-lg border p-4">
              <h2 className="text-xl font-bold mb-4 text-gray-800">Configuración</h2>
              <nav className="space-y-2">
                {secciones.map((seccion) => {
                  const Icon = seccion.icono;
                  return (
                    <button
                      key={seccion.id}
                      onClick={() => navigate(`#${seccion.id}`)}
                      className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-colors ${
                        activeSection === seccion.id
                          ? 'bg-blue-600 text-white'
                          : 'text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      <Icon className="mr-3 h-5 w-5" />
                      {seccion.nombre}
                    </button>
                  );
                })}
              </nav>
            </div>
          </div>

          {/* Content */}
          <div className="lg:w-3/4">
            <div className="bg-white rounded-lg border p-6 mb-6">
              <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold text-gray-800">
                  {secciones.find(s => s.id === activeSection)?.nombre}
                </h1>
                
              </div>
              
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfiguracionAdmin;

